import type { TourStep } from "../types";

export const suggestionsSteps: TourStep[] = [
  {
    title: "The suggestions register",
    description:
      "Every suggestion you are allowed to see. Narrow it down with the controls above the table, then open a row for the full record.",
  },
  {
    anchor: "suggestions-filters",
    title: "Filter and search",
    description:
      "Filters opens Period, Status, Category and Department. The search box matches title, suggestion number and employee. Whatever is active shows up as a chip below, and each chip clears itself.",
  },
  {
    anchor: "suggestions-toggles",
    title: "Only mine and SLA breached",
    description:
      "Two quick facets. Only mine narrows to suggestions you submitted or that were submitted on your behalf; SLA breached lists the ones that ran past the 90-day service window.",
  },
  {
    anchor: "suggestions-table",
    title: "The list",
    description:
      "Click any row to open that suggestion — its full text, attachments, committee evaluations, notes and status history.",
  },
  {
    anchor: "new-suggestion-cta",
    title: "Submit a new suggestion",
    description:
      "Same destination as the sidebar row, kept in reach while you browse the register.",
  },
];
